export const NotificationButtonColors = {
  attentionIcon: '#85D4D3',
  attentionBackground: '#3EB9B7',
  dangerIcon: '#FF7461',
  dangerBackground: '#FF5140'
};
export const ModalButtonColors = {
  danger: '#FF7461',
  dangerHover: '#FF5140',
  dangerFocus: '#f24a3a',
  primary: '#0065ff',
  primaryHover: '#1c77ff',
  primaryFocus: '#1c6feb',
  flat: 'rgba(255, 255, 255, 0.0)',
  flatHover: 'rgba(108, 117, 125, 0.26)',
  flatFocus: 'rgba(108, 117, 125, 0.66)'
};
export const navbarTheme = '#495565';
export const title = '#606B78';
export const text = '#575757';
export const description = '#737C87';
export const secondaryText = '#00C1BF';
export const primaryTheme = '#007BFF';
export const sideBarHover = '#0056b3';
export const secondaryButton = '#A4AAB2';
export const secondaryButtonBackground = '#EEEFEE';
export const border = '#CED4DA';
export const overlay = '#4e535b';
export const pieColorScale = [
  '#495565',
  '#5695FC',
  '#7BA8F3',
  '#A9C1F1',
  '#C9DAF3'
];
export const inputGlow = 'rgba(0, 123, 255, 0.25)';
export const primaryBarColor = '#3EB9B7';
export const secondaryBarColor = '#FF5140';
export const activeTabButtonColor = '#516076';
export const tabButtonColor = '#F1F3F5';
export const tabButtonText = '#4B627A';
export const axis = '#DAE0E5';
export const axisLabel = '#99A0A8';
export const legendLabel = '#A9AFB7';
export const lightSlateGray = '#7F8793';
export const chateauGray = '#9FA8B0';
export const dustyGray = '#979797';
export const lynch = '#6C798F';
export const fiord = '#3F566E';
export const sanJuan = '#495566';
export const fuscousGray = '#3C3C3C';
export const porcelain = '#F0F3F5';
export const lightPorcelain = '#fbfcfc';
export const athensGray = '#EEF0F2';
export const iron = '#CCCCCC';
export const electricBlue = '#0596CD';
export const malibu = '#79a6f6';
export const dullCyan = '#47C1BF';
export const errorRed = '#D0021B';
export const greyText = '#42526e';
export const blueGrey = '#7d92b0';
export const perryWinkle = '#a4c0e9';
export const spruce = '#485568';
export const lightSanJuanGray = '#9b9b9b';
export const lineSeparatorGray = 'rgba(151, 151, 151, 0.38)';
export const slate = '#495566';
export const dodgerBlue = '#5392ff';
export const astronautBlue = '#42526e';
export const paleGrey = '#f4f7f7';

// Shadows
export const transparentShadow = 'rgba(0, 0, 0, 0.1)';
export const darkShadow = 'rgba(23, 43, 77, 0.32)';
export const inputShadowY = 'rgba(63, 63, 68, 0.15)';
export const inputShadowX = 'rgba(63, 63, 68, 0.05)';
export const modalShadow = 'rgba(37, 38, 94, 0.1)';

// Themes
export const blueCrossTheme = '#0193cf';



// WEBPACK FOOTER //
// ./src/components/style/Colors.style.js